// ============================================================================
// ui/shell/powered-by.js — bottom-right "Powered by" badge (reusable shell)
// ============================================================================
// Ports the Gym Designer's `.powered-by` credit (dark). The GD version pulls
// {{shop.name}} + a logo asset from Liquid; this externally-hosted bundle is
// static, so the name is passed in (WD hardcodes "Blue Sky Fitness Supply").
// Non-interactive (pointer-events:none in CSS) — it sits over the canvas as a
// quiet credit, never intercepting drags.
//
//   preview.el.appendChild(createPoweredBy('Blue Sky Fitness Supply').el);
// ============================================================================

import { h } from '../dom.js';

/**
 * @param {string} name              - brand name to credit.
 * @param {object} [opts]
 * @param {string} [opts.pre]        - the small lead-in line (default "Powered by").
 * @returns {{ el:HTMLElement }}
 */
export function createPoweredBy(name, opts = {}) {
  const { pre = 'Powered by' } = opts;
  const el = h(
    'div',
    { class: 'ds-powered-by', 'aria-hidden': 'true' },
    h('span', { class: 'ds-powered-by-pre' }, pre),
    h('span', { class: 'ds-powered-by-name' }, name),
  );
  return { el };
}
